import React from 'react';
import { Box } from '@material-ui/core';
import FsSubtitle from 'ui-elements/typography/FsSubtitle';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import BarGraphs from 'ui-elements/tables/FsTransactionRowsWithBarGraph/FsTransactionRowWithBarGraph/BarGraphs';
import { FsComponentSize } from 'globals/types';
import { FsTransactionRowWithBarGraphDataProps } from 'ui-elements/tables/FsTransactionRowsWithBarGraph/FsTransactionRowWithBarGraph/FsTransactionRowWithBarGraph';
import { TitleBox } from '../ReportRecurringTransactionsModal.style-elements';

const RecurringTransactionBarGraphContainer: React.FC<FsTransactionRowWithBarGraphDataProps> = ({
  title,
  category,
  id,
  graphs,
}) => {
  return (
    <Box marginBottom={4}>
      <TitleBox>
        <FsSubtitle>{title}</FsSubtitle>
        <FsBodySmall>{category}</FsBodySmall>
      </TitleBox>
      <BarGraphs key={id} graphs={graphs} size={FsComponentSize.L} />
    </Box>
  );
};

export default RecurringTransactionBarGraphContainer;
